var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolC2PaIcTamper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 13.75V47.5C55 51.6425 43.8075 55 30 55C16.1925 55 5 51.6425 5 47.5V13.75",
    stroke: "#0057D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36.25C55 40.3925 43.8075 43.75 30 43.75C16.1925 43.75 5 40.3925 5 36.25M55 25C55 29.1425 43.8075 32.5 30 32.5C16.1925 32.5 5 29.1425 5 25",
    stroke: "#0057D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20C43.8071 20 55 16.6421 55 12.5C55 8.35786 43.8071 5 30 5C16.1929 5 5 8.35786 5 12.5C5 16.6421 16.1929 20 30 20Z",
    stroke: "#0057D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolC2PaIcTamper);
export default __webpack_public_path__ + "static/media/sol-c2pa-ic-tamper.83fedff05f56054e7201574f105e4e22.svg";
export { ForwardRef as ReactComponent };